import React from 'react';
import ProcessList from './components/ProcessList';

const Procesos: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="container mx-auto">
        <ProcessList />
      </div>
    </div>
  );
};

export default Procesos;
